<template>
  <div>
    <ConfirmReferenceBooksDialog />

    <v-dialog v-model="showReferenceBooksDialog" scrollable :width="500" >
      <v-card style="background: #F4F6F7">
        <v-card-title class="pa-0 mb-4" style="background: #FFF">
          <div class="add-on-heading">
            <div class="add-on-banner"><div>Reference Books</div></div>
            <span flat icon color="itoviGrayMid" @click="$store.commit('setShowReferenceBooksDialog', false)"><v-icon>close</v-icon></span>
          </div>

          <div class="text-xs-center mt-2" style="width: 100%;">We offer Monthly and Annual subscriptions</div>
          <v-layout row class="mt-3">
            <v-flex xs6 class="text-xs-center pb-1" :class="monthlyTab ? 'txt-bold' : ''"
                    style="cursor: pointer; font-size: 15px;" :style="monthlyTab ? 'border-bottom: 4px solid #6D2E69' : ''"
                    @click="billedMonthly()">BILLED MONTHLY</v-flex>

            <v-flex xs6 class="text-xs-center pb-1" :class="!monthlyTab ? 'txt-bold' : ''"
                    style="cursor: pointer; font-size: 15px;" :style="!monthlyTab ? 'border-bottom: 4px solid #6D2E69' : ''"
                    @click="billedAnnually()">BILLED ANNUALLY</v-flex>
          </v-layout>
        </v-card-title>
        <template v-if="addOns">

          <!-- Available addons -->
          <v-card-text class="pa-0">
            <!-- TODO: add device type to condition for ios -->
            <v-card-text v-if="is_mobile_app_webview && isIos()">
              Access your iTOVi Dashboard on the web to manage Add-ons & Premium Content.
            </v-card-text>
            <div class="" v-else>
              <add-ons-list :monthlyTab="monthlyTab" />
              <add-ons-list :monthlyTab="monthlyTab" addOnType="applied" />
              <!-- Cart -->
              <h2 class="text-xs-center mb-5 itoviPurple--text"><v-icon class="mr-2" color="itoviPurple">fas fa-shopping-cart</v-icon> Shopping Cart</h2>
              <template v-for="(item, index) in referenceBookCart">
                <v-layout :key="`${index}-${item.name}`" row align-center justify-center class="mb-3 pl-4 pr-4" v-if="item.inCart !== undefined && item.inCart !== ''">
                  <v-flex xs8 class="plan-title itoviPurple--text pr-3">
                    <v-layout>{{ item.name }}</v-layout>
                  </v-flex>
                  <v-flex xs3 class="plan-title">
                    <v-layout justify-end>
                      {{ item.name === "Extended Warranty" ? `$${formatPrice(item.price)}` : null }}
                      {{ item.inCart === "monthly" ? `$${formatPrice(item.monthly)}/month` : null }}
                      {{ item.inCart === "annually" ? `$${formatPrice(item.yearly)}/year` : null }}
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 class="ml-2" >
                    <v-layout align-center justify-end>
                      <img src="../../../assets/trash.svg" style=" width:12px; height: auto; cursor: pointer;" @click="removeFromCart(item.id)" alt="trash" >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </template>

              <v-layout justify-center class="mt-5 mb-4">
                  <button v-if="referenceBookCart.length" class="button-purple" @click="showConfirmAddOnDialog()">SUBSCRIBE</button>
                  <p class="itoviPurple--text" v-else>Your cart is empty!</p>
              </v-layout>
            </div>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AddOnsList from "@/components/dashboard/yourPlanCard/AddOnsList";
  import ConfirmReferenceBooksDialog from "./ConfirmReferenceBooksDialog"
  import subscribeToStore from "@/mixins/subscribeToStore";
  import deviceType from "@/mixins/deviceType";
  import store from '../../../store'

  export default {
    components: {
      AddOnsList,
      ConfirmReferenceBooksDialog,
    },
    mixins: [subscribeToStore, deviceType],
    data: ()=> ({
      addOns: store.state.addOns,
      addOnToCancel: null,
      addOnYearlyOption: false,
      showReferenceBooksDialog: store.state.showReferenceBooksDialog,
      is_mobile_app_webview: false,
      monthlyTab: true,
      referenceBookCart: store.state.referenceBookCart
    }),
    created(){
      this.is_mobile_app_webview = this.$route.query.hasOwnProperty('apptoken');
    },
    mounted() {
      this.subscribeToStore(['addOns', 'referenceBookCart', 'showReferenceBooksDialog', 'url']);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async showConfirmAddOnDialog() {
        // console.log(addOn);
        // console.log(this.is_mobile_app_webview);
        let addOns = [];
        for (let i = 0; i < this.addOns.available.length; i++) {
          let addOn = this.addOns.available[i];
          if (addOn.hasOwnProperty("inCart") && addOn.inCart !== undefined && addOn.inCart !== "") {
            addOns.push(addOn);
          }
        }
        store.commit('setShowConfirmPurchaseDialog', true);
      },
      billedMonthly() {
        this.monthlyTab = true;
      },
      billedAnnually() {
        this.monthlyTab = false;
      },
      removeFromCart(id) {
        const items =this.referenceBookCart.filter((item) => item.id !== id);
        this.$store.commit('setReferenceBookCart', items);
      }
    }
  }
</script>
